import { styleName } from "@/config/const";
import { useCmsStore } from "../AppHooks";
import { TDdpMedia } from "@/shared/types";
import { DdpImage } from "./DdpImage";
import { DdpVideo } from "./DdpVideo";
import { Marquee } from "./Smirnoff/Marquee";

export function Loading({ show, loading }: {
    show: boolean, loading: {
        loadingText: string
        backgroundMedia: Array<TDdpMedia>
    }
}) {
    const { storeConfig: {
        storeStyleName
    } } = useCmsStore()!
    if (!show) {
        return null;
    }
    return <>
        {storeStyleName === styleName.SmirnoffKenya && <SmirnoffLoading loading={loading} />}
        {storeStyleName === styleName.Master && <MasterLoading loading={loading} />}
        {storeStyleName === styleName.Tanqueray && <TanquerayLoading loading={loading} />}
    </>
}
const MasterLoading = ({ loading }: {
    loading: {
        loadingText: string
        backgroundMedia: Array<TDdpMedia>
    }
}) => {
    return <div className="loading-container page-container">
        <div className="loading-media-wrapper">
            {
                loading.backgroundMedia.map((item, index) => (
                    <div className="loading-img" key={index}>
                        <DdpImage key={index} image={item} />
                    </div>
                ))
            }
        </div>
        <Marquee className="loading-marquee-master" gap={22} speed={{
            desktop: 10,
            mobile: 10
        }}>
            <h1 className="loading-title"> {loading.loadingText}</h1>
        </Marquee>

    </div >
}
const SmirnoffLoading = ({ loading }: {
    loading: {
        loadingText: string
        backgroundMedia: Array<TDdpMedia>
    }
}) => {
    return <div className="loading-container loading-smirnoff-container page-container">
        <div className="loading-media-wrapper">
            <Marquee className="loading-marquee-smirnoff" gap={22} speed={{
                desktop: 10,
                mobile: 10
            }}>
                <h1 className="loading-title"> {loading.loadingText}</h1>
            </Marquee>
            <DdpImage image={loading.backgroundMedia[0]} />
        </div>

    </div >
}
const TanquerayLoading = ({ loading }: {
    loading: {
        loadingText: string
        backgroundMedia: Array<TDdpMedia>
    }
}) => {
    return <div className="loading-container loading-tanqueray-container">

        <DdpVideo video={loading.backgroundMedia[0]} muted loop autoPlay className="w-full h-full object-cover" />
        <h1 className="loading-title"> {loading.loadingText}</h1>
    </div >
}
